import { MdCancel } from "react-icons/md";
import { FiAlertCircle, FiArrowRight, FiChevronDown, FiClock, FiFileText, FiMessageSquare, FiMicOff, FiPause, FiPhone, FiPhoneIncoming, FiPhoneOutgoing, FiPlay, FiVolume2 } from "react-icons/fi";
import { BsPerson, BsRobot } from "react-icons/bs";
import { MdOutlineAnalytics } from "react-icons/md";
import { RiCustomerService2Fill } from "react-icons/ri";
import { FiCheckCircle } from "react-icons/fi";

export const CallHistorySectionContent = ({
  records,
  audioRef,
  setIsPlaying,
  setPlayingId,
  callHistoryIncoming,
  handlePlay,
  playingId,
  isPlaying,
  setAnalysisCall,
  analysisCall,
}) => (
  <div className="adp-call-history-body">
    <audio
      ref={audioRef}
      style={{ display: "none" }}
      onEnded={() => {
        setIsPlaying(false);
        setPlayingId(null);
      }}
    />

    {records.length === 0 ? (
      <div className="adp-empty-text">
        No {callHistoryIncoming ? "incoming" : "outgoing"} call history found.
      </div>
    ) : (
      <div className="adp-call-history-flat-list">
        <div className="adp-call-history-cards">
          {records.map((record, index) => (
            <div className="adp-call-history-card" key={record.id || `call-${index}`}>
              <div className="adp-call-history-card-strip" />
              <div className="adp-call-history-card-header">
                <div className="adp-call-history-agent">
                  {record.analysis && (
                    <div className="adp-call-history-recording-row">
                      <button
                        className="adp-call-history-play-btn"
                        type="button"
                        title="Play Recording"
                        onClick={() => handlePlay(record)}
                      >
                        {playingId === record.id && isPlaying ? <FiPause size={14} /> : <FiPlay size={14} />}
                      </button>
                    </div>
                  )}

                  <div>
                    <div className="adp-call-history-agent-email">{record.agentEmail}</div>
                    <div className="adp-call-history-date">
                      <FiClock size={12} /> {record.date}
                    </div>
                    <span className="adp-call-history-vin-inline">{record.requestID || "NA"}</span>
                  </div>
                </div>

                {record.analysis ? (
                  <div className="adp-call-history-duration-badge">
                    <FiClock size={12} /> {record.duration}
                  </div>
                ) : (
                  <div className="adp-call-history-no-recording">No Recording</div>
                )}
              </div>

              <div className="adp-call-history-card-body">
                <div className="adp-call-history-info-row">
                  <div className="adp-call-history-info-box">
                    <span className="adp-call-history-info-icon">
                      <FiPhoneOutgoing style={{ color: "#1976d2" }} />
                    </span>
                    <div>
                      <span className="adp-call-history-label">From</span>
                      <span className="adp-call-history-value">{record.from}</span>
                    </div>
                  </div>

                  <div className="adp-call-history-info-divider" />

                  <div className="adp-call-history-info-box">
                    <span className="adp-call-history-info-icon">
                      <FiPhone style={{ color: "#2e7d32" }} />
                    </span>
                    <div>
                      <span className="adp-call-history-label">To</span>
                      <span className="adp-call-history-value">{record.to}</span>
                    </div>
                  </div>
                </div>

                <div className="adp-call-history-notes-box">
                  <div className="adp-call-history-notes-heading">
                    <span className="adp-call-history-label">
                      <FiFileText size={10} /> Notes
                    </span>
                  </div>
                  <p className="adp-call-history-notes-text">{record.notes}</p>
                </div>

                <div className="adp-ca-trigger-row">
                  <span
                    className={`adp-call-history-status ${String(record.status)
                      .toLowerCase()
                      .replace(/\s+/g, "-")}`}
                  >
                    {record.status}
                  </span>

                  {record.analysis && (
                    <button
                      className="adp-ca-trigger-btn"
                      type="button"
                      onClick={() => setAnalysisCall(record)}
                    >
                      <MdOutlineAnalytics size={11} />
                      <span>Analysis</span>
                      <FiChevronDown
                        size={10}
                        style={{
                          transition: "transform 0.2s",
                          transform: analysisCall?.id === record.id ? "rotate(180deg)" : "rotate(0deg)",
                        }}
                      />
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
);

export const CallAnalysisModal = ({
  analysisCall,
  closeAnalysisModal,
  handlePlay,
  playingId,
  isPlaying,
}) => {
  if (!analysisCall) return null;

  return (
    <div className="adp-ca-backdrop" onClick={closeAnalysisModal}>
      <div className="adp-ca-modal" onClick={(event) => event.stopPropagation()}>
        <div className="adp-ca-modal-header">
          <div className="adp-ca-modal-title">
            <MdOutlineAnalytics size={15} />
            <span>Call Details</span>
          </div>
          <button className="adp-ca-modal-close" type="button" onClick={closeAnalysisModal}>
            <MdCancel size={20} />
          </button>
        </div>

        <div className="adp-ca-modal-body">
          <div className="adp-ca-col adp-ca-col-left">
            <div className="adp-ca-section-label">
              <FiVolume2 size={10} /> Audio Recording
            </div>
            <div className="adp-ca-info-header">
              {analysisCall.recordingKey ? (
                <button className="adp-ca-play-btn" type="button" onClick={() => handlePlay(analysisCall)}>
                  {playingId === analysisCall.id && isPlaying ? <FiPause size={15} /> : <FiPlay size={15} />}
                </button>
              ) : (
                <div className="adp-ca-no-avatar">
                  <FiMicOff size={15} /> No recording available
                </div>
              )}
              <div className="adp-ca-agent-info">
                <span className="adp-ca-agent-name">{analysisCall.agentEmail || "NA"}</span>
                <span className="adp-ca-agent-date">
                  <FiClock size={10} />
                  {analysisCall.date || "NA"}
                </span>
              </div>

              {analysisCall.recordingKey && (
                <div className="adp-ca-duration-pill">
                  <FiClock size={10} />
                  <span>{analysisCall.duration}</span>
                </div>
              )}
            </div>

            <div className="adp-ca-section-label">
              <FiPhone size={10} /> Call Route
            </div>
            <div className="adp-ca-from-to">
              <div className="adp-ca-route-box from">
                <span className="adp-ca-route-label">
                  <FiPhoneOutgoing size={10} /> From
                </span>
                <span className="adp-ca-route-value">{analysisCall.from || "NA"}</span>
              </div>
              <div className="adp-ca-route-arrow">
                <FiArrowRight size={14} />
              </div>
              <div className="adp-ca-route-box to">
                <span className="adp-ca-route-label">
                  <FiPhoneIncoming size={10} /> To
                </span>
                <span className="adp-ca-route-value">{analysisCall.to || "NA"}</span>
              </div>
            </div>

            <div className="adp-ca-section-label">
              <FiFileText size={10} /> Notes
            </div>
            <p className="adp-ca-notes-text">{analysisCall.notes || "No notes added."}</p>
            <div className="adp-ca-section-label">
              <FiCheckCircle size={10} /> Call Status
            </div>

            <div className="adp-ca-call-status-wrap">
              <span
                className={`adp-ca-notes-text ${String(analysisCall.status || "")
                  .toLowerCase()
                  .replace(/\s+/g, "-")}`}
              >
                {analysisCall.status || "NA"}
              </span>
            </div>
            {analysisCall.analysis?.call_issues && (
              <>
                <div className="adp-ca-section-label adp-ca-issues-label">
                  <FiAlertCircle size={10} /> Issues
                </div>
                <p className="adp-ca-block-text issues">{analysisCall.analysis.call_issues}</p>
              </>
            )}
          </div>

          <div className="adp-ca-col adp-ca-col-right">
            <div className="adp-ca-section-label">
              <BsRobot size={10} /> Call Analysis
            </div>
            <div className="adp-ca-sentiment-row">
              <div className="adp-ca-sentiment agent">
                <RiCustomerService2Fill size={15} />
                <div>
                  <span className="adp-ca-sent-label">Agent</span>
                  <span className="adp-ca-sent-value">{analysisCall.analysis?.agent_sentiment || "NA"}</span>
                </div>
              </div>
              <div className="adp-ca-sentiment customer">
                <BsPerson size={15} />
                <div>
                  <span className="adp-ca-sent-label">Customer</span>
                  <span className="adp-ca-sent-value">{analysisCall.analysis?.customer_sentiment || "NA"}</span>
                </div>
              </div>
            </div>

            {analysisCall.analysis?.call_summary && (
              <>
                <div className="adp-ca-section-label">
                  <FiFileText size={10} /> Summary
                </div>
                <p className="adp-ca-block-text">{analysisCall.analysis.call_summary}</p>
              </>
            )}

            {analysisCall.analysis?.call_transcript?.length > 0 && (
              <>
                <div className="adp-ca-section-label">
                  <FiMessageSquare size={10} /> Transcript
                </div>
                <div className="adp-ca-transcript-list">
                  {analysisCall.analysis.call_transcript.map((line, index) => {
                    const isCustomer = String(line).startsWith("Customer:");
                    const text = String(line).replace(/^(Customer|Agent):\s*/, "");
                    return (
                      <div key={`${analysisCall.id}-transcript-${index}`} className={`adp-ca-bubble-row ${isCustomer ? "agent" : "customer"}`}>
                        <div className="adp-ca-bubble">
                          <span className="adp-ca-speaker">
                            {isCustomer ? <><BsPerson size={9} /> Customer</> : <><RiCustomerService2Fill size={9} /> Agent</>}
                          </span>
                          <p className="adp-ca-bubble-text">{text}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            )}

            {typeof analysisCall.analysis === "string" && (
              <p className="adp-ca-block-text">{analysisCall.analysis}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const CallHistoryModal = ({ isOpen, onClose, title = "Call History", headerActions, children }) => {
  if (!isOpen) return null;

  return (
    <div className="adp-section-modal-overlay" >
      <div className="adp-section-modal" >
        <div className="adp-section-modal-header">
          <span>{title}</span>
          <div className="adp-section-modal-header-actions">
            {headerActions}
            <button className="adp-section-modal-close" type="button" onClick={onClose} aria-label="Close Call History">
              <MdCancel size={25} />
            </button>
          </div>
        </div>
        <div className="adp-section-modal-body call-history-modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default CallHistoryModal;
